import React, { useEffect, useRef, useState } from 'react';
import { Heading, Flex } from '@chakra-ui/react'
import { useParams } from "react-router-dom";
import * as d3 from 'd3';
import CommonVars from "../components/CommonVars";
import axios from 'axios';

function DataScreen () {
	if (localStorage.getItem('token') === null || JSON.parse(localStorage.getItem('userDetails')).role !== "admin") {
        window.location.replace("/unauthorized");
    }
    const theToken = localStorage.getItem('token');
	const [productSummary, setProductSummary] = useState('');
	const productid = parseInt(useParams().productid);
	
	// get product sales summary from server
    const getProductSales = async () => {
        axios.get(`${CommonVars.API_URL}/data-visual/product/${productid}`, { headers: { Authorization: `Bearer ${theToken}` } })
        .then((res) => {
			if (res.data.length === 0) {
				window.location.replace('/no-sales-data');
			}
            setProductSummary(res.data);
        })
        .catch((err) => {
            console.log(err);
        })
    }
	const productSales = productSummary;

    // set up the chart ref
	const d3BarChart = useRef()

	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	})
	// ref for resize event update
	const update = useRef(false)

	useEffect(() => {
		getProductSales();
		// windowAddEventListener tol isten for any resize event
		window.addEventListener('resize', ()=>{
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});

			// when there is a resize remove the previous chart
			if(update.current){
				d3.selectAll('g').remove()
			} else {update.current = true}
		});

		// draw the bar chart using the data and the updated dimensions
		DrawChart(productSales, dimensions);
	});

	const margin = { top: 40, right: 5, bottom: 5, left: 25 }

	function DrawChart(data) {
		const chartWidth = parseInt(d3.select('#d3BChart').style('width')) - margin.left - margin.right;
        const chartHeight = parseInt(d3.select('#d3BChart').style('height')) - margin.top - margin.bottom;

        // set up the size of the svg
		const svg = d3.select(d3BarChart.current)
					  .attr('width', chartWidth + margin.left + margin.right)
					  .attr('height', chartHeight + margin.top + margin.bottom)

        // create the x and y axis

		// x scale
        // need to determine how many data objects are there 
        // output width of the chart excluding right and left margin
		const xScale = d3.scaleBand()
					.domain(d3.range(data.length))
					.range([margin.left, chartWidth - margin.right])
					.padding(0.3);

        // call the x axis and use the month as the label
		svg.append('g')
			.attr('transform', 'translate(0,'+ chartHeight + ')')
			.call(d3.axisBottom(xScale).tickFormat(i => data[i].month).tickSizeOuter(0));

        // y scale
        // determine max value from all the quantity
		const max = d3.max(data, (d) => {
            return d.totalsales;
        });

		// output in the range of the height and the top margin
		const yScale = d3.scaleLinear()
					.domain([0, max])
					.range([chartHeight, margin.top]);

        // call the y axis with the quantity values
		svg.append('g')
			.attr('transform', 'translate(' + margin.left + ', 0)')
			.call(d3.axisLeft(yScale));

		// output the bars
        // append rectangles 4 attributes (position x, y, height and width of each bar)
        // use xScale and yScale to translate the numbers
		svg.append('g')
			.attr('fill','#3e424b')
			.selectAll('rect')
			.data(data)
			.join('rect')
			.attr('x', (d, i) => xScale(i))
			.attr('y', d => yScale(d.totalsales))
			.attr('height', d => yScale(0) - yScale(d.totalsales))
			.attr('width', xScale.bandwidth())
	}

	return (
		<Flex bg="#F4F4F4" align="center" justify="center" h="90vh">
			<div id='d3BChart'>
				<Heading pb={8}>Units Sold</Heading>
				<svg ref={d3BarChart}></svg>
			</div>
		</Flex>
	);
}

export default DataScreen;
